<mat-form-field appearance="outline" subscriptSizing="dynamic" class="column-template-input__field">
  <mat-label>{{ label | translate }}</mat-label>
  <input
    #input
    matInput
    [formControl]="control"
    [matAutocomplete]="columnCompletion"
    (focus)="refresh(input)"
    (click)="refresh(input)"
    (input)="refresh(input)"
    (keyup)="onKeyup($event, input)"
    (blur)="onBlur(columnCompletion.isOpen)"
  >
  <mat-autocomplete
    #columnCompletion="matAutocomplete"
    autoActiveFirstOption
    (optionSelected)="onSelected($event, input)"
    (closed)="onClosed(input)"
  >
    @for (completion of completions; track completion.column) {
      <mat-option [value]="completion.template">
        <span class="column-template-input__column">{{ completion.column }}</span>
        @if (firstSample(completion.column); as sample) {
          <span class="column-template-input__sample">{{ sample }}</span>
        }
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
